const TAKEOVER_CLOSED_KEY = 'takeroverclosed'
const TAKEOVER_CLOSED_VALUE = '1'

export default () => ({
    isActive: false,
    init() {
        if (
            window.localStorage.getItem(TAKEOVER_CLOSED_KEY) ===
            TAKEOVER_CLOSED_VALUE
        ) {
            return
        }

        const boundOnKeyUp = this.boundOnKeyUp.bind(this)

        this.$watch('isActive', (isActive) => {
            if (isActive) {
                window.addEventListener('keyup', boundOnKeyUp)
            } else {
                window.removeEventListener('keyup', boundOnKeyUp)
            }
        })

        this.isActive = true
    },

    boundOnKeyUp(event) {
        if (event.key === 'Escape') {
            this.close()
        }
    },

    close() {
        window.localStorage.setItem(TAKEOVER_CLOSED_KEY, TAKEOVER_CLOSED_VALUE)

        this.isActive = false
    },
})
